
(function(){
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var homepageMedia = window.ourRfkMedia || {};
  function mediaAsset(group, key){
    var collection = homepageMedia[group] || {};
    var asset = collection[key] || {};
    return { url: asset.url || '', alt: asset.alt || '' };
  }

  /* ---------- Hero load-in ---------- */
  var hero = document.querySelector('.hero');
  if (hero) {
    requestAnimationFrame(function(){ hero.classList.add('is-ready'); });
  }

  document.addEventListener('click', function(event){
    var trigger = event.target.closest('[data-scroll-top]');
    if (!trigger) return;
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
  });

  /* ---------- Scroll reveals (IntersectionObserver) ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduce.matches) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* ---------- FAQs ---------- */
  document.querySelectorAll('.faq__question').forEach(function(button){
    button.addEventListener('click', function(){
      var panelId = button.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      var item = button.closest('.faq__item');
      var isOpen = button.getAttribute('aria-expanded') === 'true';

      if (!panel || !item) return;

      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;
      item.classList.toggle('is-open', !isOpen);
    });
  });

  /* ---------- Map: district click state ----------
     Opening adds .is-open to the section, which drives everything from
     CSS: the map scales to 1.8, the labels grow 22px -> 32px, the subtext
     collapses so the headline block condenses, and the modal slides in
     from the right. Closing reverses all of it, returning the map to its
     original framing. Each district point opens the detail panel and the
     pager cycles the remaining districts. Lives above the motion guard
     because it is interaction. */
  var mapSection = document.querySelector('.map');
  var mapStadium = document.getElementById('mapPointStadium');
  var mapClose   = document.getElementById('mapClose');
  var mapModal   = document.getElementById('mapModal');
  var mapPrev    = document.getElementById('mapPrev');
  var mapNext    = document.getElementById('mapNext');
  var mapPagerNum= document.getElementById('mapPagerNum');
  var mapTitle   = document.getElementById('mapModalTitle');
  var mapDesc    = document.querySelector('.map__desc');
  var mapBullets = document.querySelector('.map__bullets');
  var mapPoints  = mapSection
    ? Array.prototype.slice.call(mapSection.querySelectorAll('.map-point'))
    : [];
  var mapOpener  = null;

  function scrollMapToTop(){
    var target = mapCanvas || document.getElementById('mapCanvas') || mapSection;
    if (!target) return;
    var top = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
    /* The mobile primary nav is fixed to the viewport. Keep the map canvas
       below it when an interaction brings the map into view. */
    if (window.matchMedia('(max-width: 760px)').matches) {
      var mobileNav = document.querySelector('.site-nav');
      if (mobileNav) top -= mobileNav.getBoundingClientRect().height + 80;
    }
    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduce.matches || window.matchMedia('(max-width: 760px)').matches
        ? 'auto'
        : 'smooth',
    });
  }

  /* The six districts, in the order they read left-to-right across the map,
     which is the order the pager walks. */
  var DISTRICTS = [
    { slug:'anacostia', title:'Anacostia Commons',
      desc:'The northern gateway to the campus, where the street grid meets the river park and the neighborhood arrives on foot.',
      bullets:['Direct pedestrian link from Benning Road',
               'Year-round market and event lawn',
               'Restored tidal wetland edge'] },
    { slug:'plaza', title:'Plaza District',
      desc:'The civic front door. A hard-surfaced gathering space sized for event-day crowds and quiet weekday use alike.',
      bullets:['Transit plaza at the Stadium-Armory portal',
               'Ground-floor retail on three sides',
               'Flexible space for 12,000 on event days'] },
    { slug:'stadium', title:'Stadium District',
      desc:'The 65,000-seat roofed venue and its grounds. Football Sundays, concerts, and the biggest events in the country.',
      bullets:['65,000 seats under a transparent roof',
               '200+ events a year beyond football',
               'The Commanders return in 2030'] },
    { slug:'riverfront', title:'Riverfront',
      desc:'Two miles of restored Anacostia shoreline, returning the water\u2019s edge to the public for the first time in sixty years.',
      bullets:['Continuous waterfront trail and boardwalk',
               'Boathouse and paddle launch',
               'Living shoreline replacing hard bulkhead'] },
    { slug:'recreation', title:'Recreation District',
      desc:'Everyday sport for the neighborhoods that surround the campus \u2014 fields, courts and a community sportsplex.',
      bullets:['Indoor sportsplex open year-round',
               'Twelve multi-use fields and courts',
               'Priority booking for Ward 7 leagues'] },
    { slug:'kingman', title:'Kingman Commons',
      desc:'The quiet end of the campus, holding the bridge to Kingman and Heritage Islands and their protected habitat.',
      bullets:['Pedestrian bridge to the islands',
               'Environmental education center',
               'Habitat buffer held free of development'] }
  ];

  var mapIndex = 2;                 /* Stadium District — the entry point */
  var mapBusy = false;
  var mapQueued = null;
  var mapTimer = null;
  var SWAP_MS  = 180;
  var MAP_SCALE = 1.92;             /* the zoom factor the design crop implies */
  var MAP_MIN_T = 100 - 100 * MAP_SCALE;   /* -92%: past this the image uncovers */
  var mapImg = document.getElementById('mapImg');

  function clampT(v){ return Math.max(MAP_MIN_T, Math.min(0, v)); }

  /* Where the active district should land. NOT the centre of the canvas —
     the panel covers the right 37%, so a centred point would sit against its
     edge. These are the coordinates the design's own click state puts the
     Stadium dot at, which is also where the previous hard-coded --ox/--oy
     placed it: framing Stadium is therefore unchanged, and the other five
     now follow the same rule. */
  var FOCAL_X = 30.166, FOCAL_Y = 58.957;

  function panFor(pt){
    return {
      tx: clampT(FOCAL_X - parseFloat(pt.style.getPropertyValue('--x')) * MAP_SCALE),
      ty: clampT(FOCAL_Y - parseFloat(pt.style.getPropertyValue('--y')) * MAP_SCALE)
    };
  }

  /* Applies a district's framing: moves the image, then recomputes where
     every point has to sit so it stays over the same ground. Same relation
     for both, so they can never drift apart. */
  function frameDistrict(slug){
    if (!mapSection || !mapImg) return;
    var target = mapSection.querySelector('.map-point[data-district="'+slug+'"]');
    if (!target) return;
    if (mapCanvas) mapCanvas.style.setProperty('--par','0px');
    var pan = panFor(target);
    mapImg.style.setProperty('--tx', pan.tx.toFixed(3) + '%');
    mapImg.style.setProperty('--ty', pan.ty.toFixed(3) + '%');
    mapImg.style.setProperty('--ms', MAP_SCALE);
    placePoints(pan.tx, pan.ty, MAP_SCALE);
  }

  /* Resting framing = the 1.08 gentle overscale about the original origin,
     which is what the closed state has always shown. */
  var REST_TX = (52.81 * (1 - 1.08)).toFixed(3);   /* -4.225 */
  var REST_TY = (52.84 * (1 - 1.08)).toFixed(3);   /* -4.227 */

  var REST_SCALE = 1.08;

  /* Place every point against a given framing. One function for both states,
     so closed and open can never use different relations. */
  function placePoints(tx, ty, scale){
    if (!mapSection) return;
    mapSection.querySelectorAll('.map-point').forEach(function(pt){
      var px = parseFloat(pt.style.getPropertyValue('--x'));
      var py = parseFloat(pt.style.getPropertyValue('--y'));
      pt.style.setProperty('--ox', (tx + px * scale).toFixed(3) + '%');
      pt.style.setProperty('--oy', (ty + py * scale).toFixed(3) + '%');
    });
  }

  function resetFraming(){
    if (mapImg) {
      mapImg.style.setProperty('--tx', REST_TX + '%');
      mapImg.style.setProperty('--ty', REST_TY + '%');
      mapImg.style.setProperty('--ms', String(REST_SCALE));
    }
    placePoints(parseFloat(REST_TX), parseFloat(REST_TY), REST_SCALE);
  }

  /* Writes one district into the panel, re-frames the map onto it and moves
     the active (yellow) point to match. */
  function paintDistrict(i){
    var d = DISTRICTS[i];
    if (!d) return;
    frameDistrict(d.slug);
    if (mapTitle) mapTitle.textContent = d.title;
    if (mapDesc)  mapDesc.textContent  = d.desc;
    if (mapBullets) {
      mapBullets.innerHTML = '';
      d.bullets.forEach(function(b){
        var li = document.createElement('li');
        var sp = document.createElement('span');
        sp.textContent = b;
        li.appendChild(sp);
        mapBullets.appendChild(li);
      });
    }
    if (mapPagerNum) mapPagerNum.textContent = String(i + 1);

    mapPoints.forEach(function(pt){
      var active = pt.getAttribute('data-district') === d.slug;
      pt.classList.toggle('is-open', active);
      pt.setAttribute('aria-expanded', active ? 'true' : 'false');
    });
  }

  function setDistrict(i, animate){
    mapIndex = (i + DISTRICTS.length) % DISTRICTS.length;
    if (!animate || !mapModal || reduce.matches) { paintDistrict(mapIndex); return; }
    mapBusy = true;
    mapModal.classList.add('is-swapping');
    mapTimer = setTimeout(function(){
      paintDistrict(mapIndex);
      mapModal.classList.remove('is-swapping');
      mapBusy = false;
      mapTimer = null;
      if (mapQueued !== null) {
        var queued = mapQueued;
        mapQueued = null;
        requestDistrict(queued);
      }
    }, SWAP_MS);
  }

  function requestDistrict(i){
    var next = (i + DISTRICTS.length) % DISTRICTS.length;
    if (mapBusy) {
      if (next === mapIndex) {
        mapQueued = null;
        return;
      }
      mapQueued = next;
      return;
    }
    setDistrict(next, true);
  }

  function requestDistrictStep(dir){
    var base = mapQueued !== null ? mapQueued : mapIndex;
    scrollMapToTop();
    requestDistrict(base + dir);
  }

  function setMapOpen(open, index, opener){
    if (!mapSection) return;
    mapSection.classList.toggle('is-open', open);
    if (open) {
      mapIndex = typeof index === 'number' ? index : mapIndex;
      mapOpener = opener || mapOpener || mapStadium;
      if (mapModal) {
        mapModal.hidden = false;
        mapModal.inert = false;
        mapModal.setAttribute('aria-hidden', 'false');
      }
      /* Keep the map points interactive while the panel is open so users can
         select a district directly as well as stepping with the pager. */
      mapPoints.forEach(function(pt){ pt.inert = false; });
      paintDistrict(mapIndex);
      if (mapClose) mapClose.focus({ preventScroll: true });
      /* Opening the panel changes the mobile canvas height and collapses the
         intro copy. Wait for that layout change before calculating the scroll
         target, otherwise the fixed nav offset is applied to stale geometry. */
      if (window.matchMedia('(max-width: 760px)').matches) {
        window.requestAnimationFrame(function(){
          window.requestAnimationFrame(scrollMapToTop);
        });
      } else {
        scrollMapToTop();
      }
    }
    else if (mapSection) {
      if (mapTimer) clearTimeout(mapTimer);
      mapTimer = null;
      mapBusy = false;
      mapQueued = null;
      if (mapModal) mapModal.classList.remove('is-swapping');
      resetFraming();
      mapPoints.forEach(function(pt){
        pt.classList.remove('is-open');
        pt.inert = false;
        pt.setAttribute('aria-expanded', 'false');
      });
      if (mapModal) {
        mapModal.inert = true;
        mapModal.setAttribute('aria-hidden', 'true');
      }
    }
    /* Move focus to the close button on open so keyboard users land inside
       the panel, and back to the originating point on close. */
    else if (!open && mapOpener) mapOpener.focus({ preventScroll: true });
  }

  mapPoints.forEach(function(point){
    point.addEventListener('click', function(){
      var slug = point.getAttribute('data-district');
      var index = DISTRICTS.findIndex(function(district){ return district.slug === slug; });
      if (index !== -1) setMapOpen(true, index, point);
    });
  });
  if (mapClose)   mapClose.addEventListener('click', function(){ setMapOpen(false); });
  if (mapPrev)    mapPrev.addEventListener('click', function(){ requestDistrictStep(-1); });
  if (mapNext)    mapNext.addEventListener('click', function(){ requestDistrictStep(1); });
  document.addEventListener('keydown', function(e){
    if (!mapSection || !mapSection.classList.contains('is-open')) return;
    if (e.key === 'Escape')     setMapOpen(false);
    if (e.key === 'ArrowLeft')  requestDistrictStep(-1);
    if (e.key === 'ArrowRight') requestDistrictStep(1);
  });

  /* Scrolling away from the component in either direction returns it to the
     initial state, so the subtext is back and the headline is re-expanded
     the next time it comes into view. */
  if (mapSection && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting && mapSection.classList.contains('is-open')) {
          mapSection.classList.remove('is-open');
          resetFraming();
          mapPoints.forEach(function(pt){
            pt.classList.remove('is-open');
            pt.inert = false;
            pt.setAttribute('aria-expanded', 'false');
          });
          if (mapModal) {
            mapModal.inert = true;
            mapModal.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }, { threshold: 0.28 }).observe(mapSection);
  }

  if (mapModal) {
    mapModal.inert = true;
    mapModal.setAttribute('aria-hidden', 'true');
  }
  mapPoints.forEach(function(pt){ pt.setAttribute('aria-expanded', 'false'); });
  /* Seed the closed framing so the points are placed against the resting
     1.08 overscale from the very first paint, not only after an open/close. */
  resetFraming();

  /* ---------- History carousel ----------
     Slides come from the timeline block (CMS), not a hardcoded year list.
     That way adding or reordering timeline_event posts updates the arrows. */
  var historySlides = [];
  var historySlidesEl = document.getElementById('rfk-history-slides');
  if (historySlidesEl) {
    try {
      historySlides = JSON.parse(historySlidesEl.textContent) || [];
    } catch (err) {
      historySlides = [];
    }
  }
  historySlides.forEach(function(slide, index){
    var media = mediaAsset('history', index);
    if (!slide.img && media.url) slide.img = media.url;
    if (!slide.alt && media.alt) slide.alt = media.alt;
  });

  var HISTORY_TOTAL = historySlides.length;
  /* One thumbnail plus one gap. Both are proportional now (8.125vw and
     0.83333vw), so the step must be measured from the rendered elements —
     a hardcoded 172px only lines up at exactly 1920px wide. */
  function thumbStep(){
    var first = historyTrack && historyTrack.children[0];
    if (!first) return 172;
    var w = first.getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(historyTrack).columnGap) || 0;
    return w + gap;
  }
  var SLIDE_MS      = 850;

  /* `historyDesired` records the user's latest intent while
     `historyCommitted` records the slide whose transition has finished.
     Keeping them separate lets repeated arrow clicks accumulate during the
     850ms animation without making the rendered state jump ahead. */
  var historyCommitted = 0;
  var historyDesired   = 0;
  var historyTransitionTarget = 0;
  var historyBusy      = false;
  var historyTransitionTimer = null;
  var historyCopyTimer = null;
  var historyTransitionToken = 0;
  var historyIncomingLayer = null;
  var historyOutgoingLayer = null;
  var historyStage   = document.getElementById('historyStage');
  var historyTrack   = document.getElementById('historyTrack');
  var historyFill    = document.getElementById('historyFill');
  var historyCurrent = document.getElementById('historyCurrent');
  var historyTotal   = document.getElementById('historyTotal');
  var historyYear    = document.getElementById('historyYear');
  var historyTitle   = document.getElementById('historyTitle');
  var historyDesc    = document.getElementById('historyDesc');
  var historyStatus  = document.getElementById('historyStatus');
  var historyLead    = document.getElementById('historyThumbLead');
  var hPrev          = document.getElementById('historyPrev');
  var hNext          = document.getElementById('historyNext');

  function historyDuration(){ return reduce.matches ? 0 : SLIDE_MS; }

  function updateHistoryRail(){
    var pct = HISTORY_TOTAL ? ((historyCommitted + 1) / HISTORY_TOTAL) * 100 : 0;
    if (historyFill) {
      var horizontal = window.matchMedia('(max-width:760px)').matches;
      historyFill.style.height = horizontal ? '2px' : pct + '%';
      historyFill.style.width  = horizontal ? pct + '%' : '2px';
    }
    if (historyCurrent) historyCurrent.textContent = historyCommitted + 1;
    if (historyTotal) historyTotal.textContent = HISTORY_TOTAL;
  }

  function updateHistoryControls(){
    if (hPrev) hPrev.disabled = (historyDesired === 0);
    if (hNext) hNext.disabled = (historyDesired === historySlides.length - 1);
    /* All thumbnails navigate to their corresponding record. */
    if (historyTrack) {
      Array.prototype.forEach.call(historyTrack.children, function(thumb, i){
        var thumbIndex = i + 1;
        var active = (thumbIndex === historyCommitted);
        thumb.classList.toggle('is-clickable', !active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
    syncHistoryThumbFocus();
  }

  function syncHistoryThumbFocus(){
    if (!historyTrack || !historyTrack.parentElement) return;
    window.requestAnimationFrame(function(){
      var viewport = historyTrack.parentElement.getBoundingClientRect();
      Array.prototype.forEach.call(historyTrack.children, function(thumb, i){
        var rect = thumb.getBoundingClientRect();
        var active = i + 1 === historyCommitted;
        var visible = rect.left >= viewport.left - 1 && rect.right <= viewport.right + 1
          && rect.top >= viewport.top - 1 && rect.bottom <= viewport.bottom + 1;
        thumb.tabIndex = visible && !active ? 0 : -1;
        thumb.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (!visible && document.activeElement === thumb) {
          var fallback = hNext && !hNext.disabled ? hNext : hPrev;
          if (fallback) fallback.focus({ preventScroll: true });
        }
      });
    });
  }

  function setHistoryCopy(n){
    var els = [historyYear, historyTitle, historyDesc].filter(Boolean);
    if (historyYear)  historyYear.textContent  = historySlides[n].year;
    if (historyTitle) historyTitle.textContent = historySlides[n].title;
    if (historyDesc)  historyDesc.textContent  = historySlides[n].desc;
    if (historyStatus) {
      historyStatus.textContent = 'Showing ' + historySlides[n].year + ': ' + historySlides[n].title;
    }
    els.forEach(function(e){ e.classList.remove('is-swapping'); });
  }

  function swapHistoryCopy(){
    var els = [historyYear, historyTitle, historyDesc].filter(Boolean);
    if (historyCopyTimer !== null) clearTimeout(historyCopyTimer);
    els.forEach(function(e){ e.classList.add('is-swapping'); });
    historyCopyTimer = setTimeout(function(){
      historyCopyTimer = null;
      /* Read the mutable target at swap time so a rapid retarget never
         exposes copy belonging to an obsolete intermediate slide. */
      setHistoryCopy(historyTransitionTarget);
    }, Math.round(historyDuration() * 0.5));
  }

  function updateHistoryTrack(n){
    if (!historyTrack) return;
    /* The strip contains slides 2–6, so advancing to the final feature
       moves the active final thumbnail fully out of the visible strip. */
    historyTrack.style.transform =
      'translate3d(' + (n * -thumbStep()) + 'px,0,0)';
  }

  function finishHistoryTransition(token){
    if (token !== historyTransitionToken) return;

    if (historyStage) {
      Array.prototype.forEach.call(
        historyStage.querySelectorAll('.history__layer'),
        function(layer){
          if (layer !== historyIncomingLayer && layer.parentNode) {
            layer.parentNode.removeChild(layer);
          }
        }
      );
    }
    if (historyIncomingLayer) {
      historyIncomingLayer.classList.remove(
        'enter-fwd', 'enter-back', 'exit-fwd', 'exit-back'
      );
      historyIncomingLayer.classList.add('is-current');
    }

    historyCommitted = historyTransitionTarget;
    historyBusy = false;
    historyTransitionTimer = null;
    historyIncomingLayer = null;
    historyOutgoingLayer = null;

    if (historyCopyTimer !== null) {
      clearTimeout(historyCopyTimer);
      historyCopyTimer = null;
      setHistoryCopy(historyCommitted);
    }
    updateHistoryRail();
    updateHistoryControls();
    continueHistoryTransitions();
  }

  function cancelHistoryTransition(){
    historyTransitionToken += 1;
    if (historyTransitionTimer !== null) clearTimeout(historyTransitionTimer);
    if (historyCopyTimer !== null) clearTimeout(historyCopyTimer);
    historyTransitionTimer = null;
    historyCopyTimer = null;

    if (historyIncomingLayer && historyIncomingLayer.parentNode) {
      historyIncomingLayer.parentNode.removeChild(historyIncomingLayer);
    }
    if (historyOutgoingLayer) {
      historyOutgoingLayer.classList.remove('exit-fwd', 'exit-back');
      historyOutgoingLayer.classList.add('is-current');
    }
    if (historyStage) {
      Array.prototype.forEach.call(
        historyStage.querySelectorAll('.history__layer'),
        function(layer){
          if (layer !== historyOutgoingLayer && layer.parentNode) {
            layer.parentNode.removeChild(layer);
          }
        }
      );
    }

    historyBusy = false;
    historyTransitionTarget = historyCommitted;
    historyIncomingLayer = null;
    historyOutgoingLayer = null;
    updateHistoryTrack(historyCommitted);
    setHistoryCopy(historyCommitted);
    updateHistoryRail();
    updateHistoryControls();
  }

  function retargetHistoryTransition(next){
    if (!historyBusy) return;
    next = clampHistoryIndex(next);
    if (next === historyCommitted) {
      cancelHistoryTransition();
      return;
    }
    if (next === historyTransitionTarget) return;

    historyTransitionTarget = next;
    if (historyIncomingLayer) {
      var img = historyIncomingLayer.querySelector('img');
      if (img) {
        img.src = historySlides[next].img;
        img.alt = historySlides[next].alt;
      }
    }
    /* If the midpoint copy swap already happened, synchronize it now.
       Otherwise its pending callback will read the new mutable target. */
    if (historyCopyTimer === null) setHistoryCopy(next);
    updateHistoryTrack(next);
    updateHistoryControls();
  }

  function goToHistory(next, dir){
    if (historyBusy) return;
    if (next < 0 || next >= historySlides.length || next === historyCommitted) return;
    historyBusy = true;
    historyTransitionTarget = next;
    var token = ++historyTransitionToken;

    /* --- Feature image: cross-animate two layers --- */
    if (historyStage) {
      var current  = historyStage.querySelector('.history__layer.is-current');
      var incoming = document.createElement('div');
      incoming.className = 'history__layer ' + (dir > 0 ? 'enter-fwd' : 'enter-back');
      var img = document.createElement('img');
      img.src = historySlides[next].img;
      img.alt = historySlides[next].alt;
      incoming.appendChild(img);
      historyStage.appendChild(incoming);
      historyOutgoingLayer = current;
      historyIncomingLayer = incoming;

      /* Two frames so the browser registers the start state before we
         transition away from it. */
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          if (token !== historyTransitionToken) return;
          incoming.classList.remove('enter-fwd', 'enter-back');
          incoming.classList.add('is-current');
          if (current) {
            current.classList.remove('is-current');
            current.classList.add(dir > 0 ? 'exit-fwd' : 'exit-back');
          }
        });
      });

      historyTransitionTimer = setTimeout(function(){
        finishHistoryTransition(token);
      }, historyDuration() + 60);
    } else {
      historyCommitted = next;
      historyTransitionTarget = next;
      historyBusy = false;
      updateHistoryTrack(next);
      setHistoryCopy(next);
      updateHistoryRail();
      updateHistoryControls();
      continueHistoryTransitions();
      return;
    }

    updateHistoryTrack(next);
    swapHistoryCopy();
    updateHistoryControls();
  }

  function clampHistoryIndex(index){
    return Math.max(0, Math.min(historySlides.length - 1, index));
  }

  /* Normally this starts a transition from rest. While busy, request
     handlers retarget the existing incoming layer instead. The post-finish
     call only covers intent arriving on the completion boundary. */
  function continueHistoryTransitions(){
    if (historyBusy || historyCommitted === historyDesired) return;
    var dir = historyDesired > historyCommitted ? 1 : -1;
    goToHistory(historyDesired, dir);
  }

  function requestHistoryStep(dir){
    historyDesired = clampHistoryIndex(historyDesired + dir);
    updateHistoryControls();
    if (historyBusy) retargetHistoryTransition(historyDesired);
    else continueHistoryTransitions();
  }

  function requestHistoryTarget(target){
    historyDesired = clampHistoryIndex(target);
    updateHistoryControls();
    if (historyBusy) retargetHistoryTransition(historyDesired);
    else continueHistoryTransitions();
  }

  if (hNext) hNext.addEventListener('click', function(){ requestHistoryStep(1); });
  if (hPrev) hPrev.addEventListener('click', function(){ requestHistoryStep(-1); });
  if (historyTrack) Array.prototype.forEach.call(historyTrack.children, function(thumb, i){
    thumb.addEventListener('click', function(){
      var target = i + 1;
      if (target === historyDesired) return;
      requestHistoryTarget(target);
    });
  });

  updateHistoryRail();
  updateHistoryControls();

  /* ---------- Discover carousel ----------
     Four images rotate through three visible slots. Slides are absolutely
     positioned; changing their left/width lets the browser animate an image
     growing into the feature slot while the others slide along.

     Slot 3 is off-screen. Which SIDE it parks on depends on direction:
       forward  -> the outgoing feature exits LEFT, the newcomer enters RIGHT
       backward -> the outgoing exits RIGHT, the newcomer enters LEFT
     An image crossing from one off-screen side to the other is repositioned
     with transitions suppressed, so it never streaks across the frame. */
  var DISCOVER_SLOTS = [
    { left: 0.0000,   width: 66.0920 },   /* feature: 920/1392 */
    { left: 67.8161,  width: 15.2299 },   /* 944/1392, 212/1392 */
    { left: 84.7701,  width: 15.2299 }    /* 1180/1392 */
  ];
  var OFF_RIGHT = { left: 101.7241, width: 15.2299 };
  var OFF_LEFT  = { left: -16.3793, width: 15.2299 };

  var discoverSlides  = Array.prototype.slice.call(
                          document.querySelectorAll('.discover__slide'));
  var discoverTotal   = discoverSlides.length || 4;
  var discoverIndex   = 0;
  var discoverBusy    = false;
  var discoverQueued  = null;
  var discoverFill    = document.getElementById('discoverFill');
  var discoverCurrent = document.getElementById('discoverCurrent');
  var discoverStatus  = document.getElementById('discoverStatus');

  function discoverRel(i, active){
    return (i - active + discoverTotal) % discoverTotal;
  }
  function isMobileDiscover(){ return window.matchMedia('(max-width:760px)').matches; }
  function discoverSlotFor(rel){
    if (isMobileDiscover()) return rel === 0 ? { left:0, width:100 } : OFF_RIGHT;
    return rel < 3 ? DISCOVER_SLOTS[rel] : OFF_RIGHT;
  }
  function setSlot(el, slot){
    el.style.left  = slot.left + '%';
    el.style.width = slot.width + '%';
  }
  function discoverDur(){ return reduce.matches ? 0 : 850; }

  function paintDiscover(active){
    discoverSlides.forEach(function(el, i){
      var rel = discoverRel(i, active);
      el.classList.toggle('is-active', rel === 0);
      /* Feature sits on top; later slots stack behind, so a shrinking
         image tucks under its neighbour rather than over it. */
      el.style.zIndex = String(10 - rel);
      el.setAttribute('aria-current', rel === 0 ? 'true' : 'false');
      var visible = isMobileDiscover() ? rel === 0 : rel < 3;
      el.tabIndex = visible && rel !== 0 ? 0 : -1;
      el.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
    if (discoverFill) {
      discoverFill.style.width = (((active + 1) / discoverTotal) * 100) + '%';
    }
    if (discoverCurrent) discoverCurrent.textContent = active + 1;
    if (discoverStatus && discoverSlides[active]) {
      discoverStatus.textContent = 'Showing ' + (discoverSlides[active].getAttribute('data-title') || 'image ' + (active + 1));
    }
  }

  function goToDiscover(next, dir){
    if (discoverBusy || !discoverSlides.length) return;
    next = (next + discoverTotal) % discoverTotal;
    if (next === discoverIndex) return;
    discoverBusy = true;

    var forward = dir > 0;
    var mobile = isMobileDiscover();
    var entry = forward ? OFF_RIGHT : OFF_LEFT;
    var exit  = forward ? OFF_LEFT  : OFF_RIGHT;

    /* Phase 1 — move any incoming slide to the correct entry side with no
       transition, so its arrival reads as a slide-in from that edge. */
    discoverSlides.forEach(function(el, i){
      var oldRel = discoverRel(i, discoverIndex);
      var newRel = discoverRel(i, next);
      if ((mobile && oldRel !== 0 && newRel === 0) ||
          (!mobile && oldRel >= 3 && newRel < 3)) {
        el.style.transition = 'none';
        setSlot(el, entry);
      }
    });
    void document.body.offsetWidth;          /* flush the reposition */

    /* Phase 2 — restore transitions and move everything to its new slot. */
    requestAnimationFrame(function(){
      discoverSlides.forEach(function(el, i){
        el.style.transition = '';
        var newRel = discoverRel(i, next);
        setSlot(el, mobile
          ? (newRel === 0 ? { left:0, width:100 } : exit)
          : (newRel < 3 ? DISCOVER_SLOTS[newRel] : exit));
      });
      paintDiscover(next);
    });

    discoverIndex = next;
    setTimeout(function(){
      discoverBusy = false;
      if (discoverQueued) {
        var queued = discoverQueued;
        discoverQueued = null;
        requestDiscover(queued.next, queued.dir);
      }
    }, discoverDur() + 60);
  }

  function requestDiscover(next, dir){
    next = (next + discoverTotal) % discoverTotal;
    if (discoverBusy) {
      if (next === discoverIndex) {
        discoverQueued = null;
        return;
      }
      discoverQueued = { next: next, dir: dir };
      return;
    }
    if (next === discoverIndex) return;
    goToDiscover(next, dir);
  }

  function requestDiscoverStep(dir){
    var base = discoverQueued ? discoverQueued.next : discoverIndex;
    requestDiscover(base + dir, dir);
  }

  var dPrev = document.getElementById('discoverPrev');
  var dNext = document.getElementById('discoverNext');
  if (dNext) dNext.addEventListener('click', function(){
    requestDiscoverStep(1);
  });
  if (dPrev) dPrev.addEventListener('click', function(){
    requestDiscoverStep(-1);
  });
  /* Clicking any inactive image promotes it straight to the feature slot,
     travelling whichever way is shorter. */
  discoverSlides.forEach(function(el){
    el.addEventListener('click', function(){
      var target = parseInt(el.getAttribute('data-index'), 10);
      if (isNaN(target) || target === discoverIndex) return;
      var fwdSteps = (target - discoverIndex + discoverTotal) % discoverTotal;
      requestDiscover(target, fwdSteps <= discoverTotal / 2 ? 1 : -1);
    });
    el.addEventListener('keydown', function(event){
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      el.click();
    });
  });

  /* Initial layout */
  discoverSlides.forEach(function(el, i){
    setSlot(el, discoverSlotFor(discoverRel(i, 0)));
  });
  paintDiscover(0);

  /* ---------- Sticky scroll navigation ----------
     Flies in once the hero is ~85% scrolled past. Lives above the motion
     guard because it is navigation, not decoration — under reduced motion
     it simply appears without the slide. */
  var stickyNav = document.getElementById('stickyNav');
  var heroSection = document.querySelector('.hero');

  function updateStickyNav(){
    if (!stickyNav || !heroSection) return;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var visible = y > heroSection.offsetHeight * 0.85 || stickyNav.contains(document.activeElement);
    stickyNav.classList.toggle('is-visible', visible);
    stickyNav.inert = !visible;
    stickyNav.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  window.addEventListener('scroll', updateStickyNav, { passive: true });
  window.addEventListener('resize', updateStickyNav, { passive: true });

  /* The step is viewport-proportional, so resizing while the carousel is on
     slide 2 would leave the track offset by the old amount. Re-apply it. */
  window.addEventListener('resize', function(){
    if (historyTrack) {
      var trackOffset = historyTransitionTarget;
      historyTrack.style.transform =
        'translate3d(' + (trackOffset * -thumbStep()) + 'px,0,0)';
      syncHistoryThumbFocus();
    }
    if (!discoverBusy) {
      discoverSlides.forEach(function(el, i){
        setSlot(el, discoverSlotFor(discoverRel(i, discoverIndex)));
      });
      paintDiscover(discoverIndex);
    }
  }, { passive: true });
  updateStickyNav();

  /* ---------- Current Status expand / collapse ----------
     Plus opens the panel, minus closes it. Above the motion guard because
     it is interaction, not decoration. The Status block renders one box per
     repeater row, so each box is wired independently off its own toggle
     rather than a single hardcoded id. */
  var statusCallouts = document.querySelectorAll('[data-status-callout]');

  Array.prototype.forEach.call(statusCallouts, function (callout) {
    var toggle = callout.querySelector('.callout__toggle');
    var reveal = callout.querySelector('.callout__reveal');
    if (!toggle || !reveal) { return; }

    var hideTimer = null;

    toggle.addEventListener('click', function () {
      var open = callout.classList.toggle('is-open');
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      if (open) {
        reveal.hidden = false;
        reveal.inert = false;
        reveal.setAttribute('aria-hidden', 'false');
      } else {
        reveal.inert = true;
        reveal.setAttribute('aria-hidden', 'true');
        hideTimer = setTimeout(function () {
          reveal.hidden = true;
          hideTimer = null;
        }, 550);
      }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = open
        ? toggle.getAttribute('data-label-hide')
        : toggle.getAttribute('data-label-show');
      if (label) {
        toggle.setAttribute('aria-label', label);
      }
    });
  });

  /* ---------- Stat count-up ----------
     Runs on every numeric stat marked [data-count] — the green Impact
     Stats figures and the Ward 7 numbers. Only the numeric portion
     animates; any prefix or suffix ($, %, M, B, hrs/wk, *) is preserved,
     comma grouping is rebuilt, and non-numeric values like "LEED Plat."
     are left untouched. Labels, captions and icons keep their own
     fade-up reveal and are not affected.
     Under reduced motion the final value shows immediately. */
  var COUNT_DURATION = 850;      /* was 1500ms */
  var countEls = document.querySelectorAll('[data-count]');

  function parseStat(raw){
    var m = raw.match(/^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/);
    if (!m) return null;
    return {
      prefix: m[1],
      suffix: m[3],
      value: parseFloat(m[2].replace(/,/g, '')),
      decimals: (m[2].split('.')[1] || '').length,
      grouped: m[2].indexOf(',') !== -1
    };
  }

  function formatStat(parts, n){
    var s = parts.decimals ? n.toFixed(parts.decimals) : String(Math.round(n));
    if (parts.grouped) {
      var bits = s.split('.');
      bits[0] = bits[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = bits.join('.');
    }
    return parts.prefix + s + parts.suffix;
  }

  function runCount(el){
    var raw = el.getAttribute('data-count');
    var parts = parseStat(raw);
    if (!parts || reduce.matches) { el.textContent = raw; return; }
    /* Single knob for how long every stat takes to reach its final value.
       The ease-out curve below front-loads the movement, so most of the
       count happens in the first half of this duration. */
    var dur = COUNT_DURATION, t0 = null;
    function step(ts){
      if (t0 === null) t0 = ts;
      var prog = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - prog, 3);      /* ease-out cubic */
      el.textContent = formatStat(parts, parts.value * eased);
      if (prog < 1) requestAnimationFrame(step);
      else el.textContent = raw;                   /* land on the exact string */
    }
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window && !reduce.matches) {
    var countIO = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          runCount(entry.target);
          countIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    Array.prototype.forEach.call(countEls, function(el){
      var raw = el.getAttribute('data-count');
      var parts = parseStat(raw);
      /* Start from zero where there's a number to count; otherwise leave
         the literal value in place. */
      el.textContent = parts ? formatStat(parts, 0) : raw;
      countIO.observe(el);
    });
  } else {
    Array.prototype.forEach.call(countEls, function(el){
      el.textContent = el.getAttribute('data-count');
    });
  }

  /* ---------- Community Voices ----------
     The selected community_voice posts own every topic, quote, attribution,
     and portrait. The active post yields its fixed card order to the quote
     panel; the remaining selected posts stay as narrow cards. */
  var voicesRow   = document.getElementById('voicesRow');
  var voicesQuote = document.getElementById('voicesQuote');
  var voicesCards = Array.prototype.slice.call(
    document.querySelectorAll('.voices__card[data-voice-id]')
  );
  var voicesData = {};
  var voicesEls = {
    tag:  document.getElementById('voicesTag'),
    text: document.getElementById('voicesQuoteText'),
    name: document.getElementById('voicesName'),
    role: document.getElementById('voicesRole'),
    ward: document.getElementById('voicesWard'),
    dot:  document.getElementById('voicesDot'),
    photo:document.getElementById('voicesHeadshot')
  };
  voicesCards.forEach(function(card){
    var id = card.getAttribute('data-voice-id');
    if (!id) return;
    voicesData[id] = {
      order: card.getAttribute('data-voice-order') || '1',
      tag: card.getAttribute('data-topic') || '',
      quote: card.getAttribute('data-quote') || '',
      name: card.getAttribute('data-name') || '',
      role: card.getAttribute('data-role') || '',
      ward: card.getAttribute('data-ward') || '',
      photo: card.getAttribute('data-photo') || '',
      alt: card.getAttribute('data-photo-alt') || ''
    };
  });
  var voicesActive = voicesCards.length
    ? voicesCards[0].getAttribute('data-voice-id')
    : '';
  var voicesBusy = false;
  var voicesQueued = null;

  function paintVoices(id){
    var d = voicesData[id];
    if (!d || !voicesQuote) return;
    voicesEls.tag.textContent  = d.tag;
    voicesEls.text.textContent = d.quote;
    voicesEls.name.textContent = d.name;
    voicesEls.role.textContent = d.role;
    voicesEls.ward.textContent = d.ward;
    voicesEls.role.hidden = !d.role;
    voicesEls.ward.hidden = !d.ward;
    voicesEls.dot.hidden = !d.role || !d.ward;
    if (d.photo) voicesEls.photo.src = d.photo;
    else voicesEls.photo.removeAttribute('src');
    voicesEls.photo.alt = d.alt || d.name;
    voicesQuote.style.setProperty('--voice-active-order', d.order);
    voicesQuote.setAttribute('data-active-voice', id);
    voicesCards.forEach(function(card){
      var active = card.getAttribute('data-voice-id') === id;
      card.hidden = active;
      card.setAttribute('aria-pressed', active ? 'true' : 'false');
      card.setAttribute('aria-current', active ? 'true' : 'false');
    });
    voicesActive = id;
  }

  /* State swap. Every slot is a fixed coordinate in CSS, so all this does is
     toggle one class and let the transition carry the quote box 236px to its
     new slot. No measuring, no inverting, no inline transforms - which is
     why it slides cleanly instead of stuttering.
     The copy inside fades out just before the swap and back in during the
     slide, so the text never visibly changes mid-motion. */
  /* Keep the fixed-size composition horizontal at any width by scaling it
     uniformly. Measuring in script because CSS cannot divide a viewport
     width by a pixel length to derive the factor. */
  var voicesStage = document.getElementById('voicesStage');

  function sizeVoices(){
    if (!voicesStage) return;
    var avail = voicesStage.clientWidth;
    if (!avail) return;
    var s = Math.min(1, avail / 1392);
    document.documentElement.style.setProperty('--voices-scale', s.toFixed(4));
  }
  sizeVoices();
  window.addEventListener('resize', sizeVoices, { passive: true });

  /* Quick crossfade in place — the box changes slot while invisible, so it
     never appears to travel across the card beside it. */
  var SWAP_FADE = 160;

  function openVoice(id){
    if (!voicesData[id]) return;
    if (voicesBusy) {
      if (id === voicesActive) {
        voicesQueued = null;
        return;
      }
      voicesQueued = id;
      return;
    }
    if (id === voicesActive) return;
    if (!voicesRow || reduce.matches) { paintVoices(id); return; }

    voicesBusy = true;
    if (voicesQuote) voicesQuote.classList.add('is-fading');

    setTimeout(function(){
      paintVoices(id);
      if (voicesQuote) voicesQuote.classList.remove('is-fading');
      setTimeout(function(){
        voicesBusy = false;
        if (voicesQueued) {
          var queued = voicesQueued;
          voicesQueued = null;
          openVoice(queued);
        }
      }, SWAP_FADE + 40);
    }, SWAP_FADE);
  }

  voicesCards.forEach(function(card){
    card.addEventListener('click', function(){
      openVoice(card.getAttribute('data-voice-id'));
    });
  });
  if (voicesActive) paintVoices(voicesActive);

  if (reduce.matches) return;   // everything below is motion

  /* ---------- Element cache ---------- */
  var heroBg      = document.getElementById('heroBg');
  var overlayBg   = document.getElementById('overlayBg');
  var overlayType = document.getElementById('overlayType');
  var headlineLines = overlayType
    ? Array.prototype.slice.call(overlayType.querySelectorAll('[data-line]'))
    : [];
  var overlaySub  = document.getElementById('overlaySub');
  var overlayHint = document.getElementById('overlayHint');
  var pinStage    = document.getElementById('pinStage');
  var scatterImgs = Array.prototype.slice.call(document.querySelectorAll('.scatter__img'));
  var mapCanvas   = document.getElementById('mapCanvas');
  var mapImg      = document.getElementById('mapImg');
  var subscribeBg   = document.getElementById('subscribeBg');
  var kingmanInset  = document.getElementById('kingmanInset');
  var kingmanMain   = document.getElementById('kingmanMain');
  var wardImage     = document.getElementById('wardImage');

  var vh = window.innerHeight;

  /* ---- Hero Overlay parallax ----
     Runs on its own animation frame and reads the scroll position fresh
     every frame, rather than reacting to scroll EVENTS. Scroll events fire
     in discrete chunks, which is what makes most parallax look steppy; this
     way the motion is resolved once per painted frame and reads as welded
     to the scrollbar.

     One signed factor drives all three layers:
        approaching -> -1 to 0
        pinned      -> exactly 0   (everything locked, per the design)
        releasing   ->  0 to 1
     Offset is -driftF x rate, so every layer travels the SAME direction and
     differs only in distance — which is what produces depth. Rates:
        photos  268-336px   (foreground, nearest)
        type     92px       (middle)
        render   28px       (far)
     Photos also carry a 2-4 degree tilt delta on the same factor, so they
     rotate into true as they settle and back out as they leave. */
  var PX_TEXT = 92;
  var PX_BG   = 28;
  var overlayRunning = false;

  function overlayFrame(){
    var pinRect  = pinStage.getBoundingClientRect();
    var visible  = pinRect.top < vh && pinRect.bottom > 0;

    if (visible) {
      var pinTotal = pinStage.offsetHeight - vh;
      var enterF = clamp((vh - pinRect.top) / vh, 0, 1);
      var exitF  = pinTotal > 0 ? clamp((-pinRect.top - pinTotal) / vh, 0, 1) : 0;
      var driftF = enterF < 1 ? -(1 - enterF) : exitF;
      var p      = pinTotal > 0 ? clamp(-pinRect.top / pinTotal, 0, 1) : 0;

      /* --- Foreground photos --- */
      /* The approach gets a longer runway than the exit. There is no text on
         screen yet on the way in, so the photos carry the section on their
         own — the extra distance and rotation give them something to do
         while the headline waits to fade up. On the way out the subcopy is
         already present, so the shorter travel stays out of its way. */
      var ENTER_BOOST = 1.55;
      var boost = driftF < 0 ? ENTER_BOOST : 1;

      var ENTER_START = 0.30, ENTER_SPAN = 0.22, ENTER_GAP = 0.07;
      scatterImgs.forEach(function(img){
        var o    = parseFloat(img.getAttribute('data-order')) || 0;
        var rate = parseFloat(img.getAttribute('data-py'))    || 0;
        var tilt = parseFloat(img.getAttribute('data-tilt'))  || 0;
        var t    = clamp((enterF - (ENTER_START + o * ENTER_GAP)) / ENTER_SPAN, 0, 1);
        img.style.opacity = 1 - Math.pow(1 - t, 3);
        img.style.transform =
          'translate(-50%,-50%) translate3d(0,' + (-driftF * rate * boost).toFixed(2) +
          'px,0) rotate(' + (-driftF * tilt * boost).toFixed(3) + 'deg)';
      });

      /* --- Middle plane: the type sequence, plus its own slower drift.
             driftF is 0 throughout the pin, so the headline-to-subcopy
             choreography is untouched while jacking. --- */
      var textDrift = -driftF * PX_TEXT;
      var HEAD_START = 0.025, HEAD_SPAN = 0.07, LINE_STAGGER = 0.028;
      var HEAD_OUT = 0.54, HEAD_OUT_SPAN = 0.11;
      var hOut = clamp((p - HEAD_OUT) / HEAD_OUT_SPAN, 0, 1);

      headlineLines.forEach(function(line, i){
        var lIn = clamp((p - (HEAD_START + i * LINE_STAGGER)) / HEAD_SPAN, 0, 1);
        line.style.opacity = lIn * (1 - hOut);
        line.style.transform = 'translate3d(0,' +
          ((1 - lIn) * 32 - hOut * 46 + textDrift).toFixed(2) + 'px,0)';
      });

      var sIn = clamp((p - 0.61) / 0.10, 0, 1);
      if (overlaySub) {
        overlaySub.style.opacity = sIn;
        overlaySub.style.transform =
          'translate3d(0,' + ((1 - sIn) * 30 + textDrift).toFixed(2) + 'px,0)';
      }
      if (overlayHint) {
        overlayHint.style.opacity = clamp((p - 0.78) / 0.09, 0, 1) * 0.5;
      }

      /* --- Far layer --- */
      if (overlayBg) {
        overlayBg.style.transform =
          'translate3d(0,' + (-driftF * PX_BG).toFixed(2) + 'px,0)';
      }
    }

    if (visible) requestAnimationFrame(overlayFrame);
    else overlayRunning = false;
  }

  function startOverlay(){
    if (overlayRunning) return;
    overlayRunning = true;
    requestAnimationFrame(overlayFrame);
  }

  function clamp(v,min,max){ return v < min ? min : v > max ? max : v; }

  /* ---------- Main scroll loop (rAF-throttled) ---------- */
  var ticking = false;

  function onScroll(){
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function update(){
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop;

    /* Every section below is an editor-placeable block, so any of them can be
       absent from the page. Each lookup is null-guarded: an unguarded one
       throws on every scroll frame and silently kills the sections after it,
       which is what happened when the campus map block was not on the page. */

    /* --- Hero background parallax: moves at 0.35× scroll speed --- */
    if (hero && heroBg) {
      var heroRect = hero.getBoundingClientRect();
      if (heroRect.bottom > 0) {
        heroBg.style.transform = 'translate3d(0,' + (y * 0.35) + 'px,0)';
      }
    }

    /* --- Hero Overlay sequence ---
       Photos float ONLY between sections. Three distinct regimes:
         approaching  (pin not yet engaged)  -> photos drift toward position
         pinned       (headline -> subcopy)   -> photos LOCKED, offset 0
         releasing    (pin let go)            -> photos drift away
       The headline/subcopy crossfade runs off pin progress and is unchanged.
       Photos never scale and never fade out. */
    /* The Hero Overlay section runs on its own frame loop (overlayFrame),
       so its motion resolves once per painted frame rather than once per
       scroll event. All update() needs to do is keep that loop alive while
       the section is anywhere near the viewport. */
    if (pinStage) {
      var pinRect = pinStage.getBoundingClientRect();
      if (pinRect.top < vh * 1.5 && pinRect.bottom > -vh * 0.5) startOverlay();
    }

    /* --- Map image: gentle counter-parallax ---
       Writes ONLY --par. Assigning style.transform here would overwrite the
       pan/zoom the district framing sets, which is exactly the bug this
       replaces. Frozen while a district is open. */
    if (mapCanvas) {
      var mapRect = mapCanvas.getBoundingClientRect();
      if (mapRect.top < vh && mapRect.bottom > 0) {
        if (mapSection && mapSection.classList.contains('is-open')) {
          mapCanvas.style.setProperty('--par', '0px');
        } else {
          var mp = (vh - mapRect.top) / (vh + mapRect.height);
          mapCanvas.style.setProperty('--par', ((mp - 0.5) * 70).toFixed(2) + 'px');
        }
      }
    }

    /* --- Subscription callout: slow background drift --- */
    if (subscribeBg) {
      var sRect = subscribeBg.parentElement.getBoundingClientRect();
      if (sRect.top < vh && sRect.bottom > 0) {
        var sp = (vh - sRect.top) / (vh + sRect.height);
        /* The image is inset -10% top and bottom against a 120% height, so
           the headroom either side is a tenth of the section — 81px at the
           current 808. Deriving the amplitude from that height instead of
           hard-coding it means the drift can never outrun the headroom and
           pull an edge into view, whatever the copy does to the section at
           other widths. 0.16 of the height = +/-8% against 10% available,
           leaving a fifth of the headroom as margin. */
        var sAmp = Math.min(150, sRect.height * 0.16);
        subscribeBg.style.transform = 'translate3d(0,' + ((sp - 0.5) * sAmp).toFixed(2) + 'px,0)';
      }
    }

    /* --- Ward 7 photo: slow rise --- */
    if (wardImage) {
      var wRect = wardImage.getBoundingClientRect();
      if (wRect.top < vh && wRect.bottom > 0) {
        var wp = (vh - wRect.top) / (vh + wRect.height);
        wardImage.style.transform = 'translate3d(0,' + ((wp - 0.5) * 60) + 'px,0) scale(1.08)';
      }
    }

    /* --- Kingman block: inset photo and main image move at
           different rates so they separate as you scroll --- */
    if (kingmanMain) {
      var kRect = kingmanMain.getBoundingClientRect();
      if (kRect.top < vh && kRect.bottom > 0) {
        var kp = (vh - kRect.top) / (vh + kRect.height);
        kingmanMain.style.transform = 'translate3d(0,' + ((kp - 0.5) * 50) + 'px,0) scale(1.06)';
        if (kingmanInset) {
          kingmanInset.style.transform = 'translate3d(0,' + ((kp - 0.5) * -70) + 'px,0)';
        }
      }
    }
  }

  /* ---------- Initial paint: set photo rotations from CSS ---------- */
  /* Rest position only. Rotation is baked into each export, so there is no
     base rotate here — the loop layers a small delta on top. */
  scatterImgs.forEach(function(img){
    img.style.transform = 'translate(-50%,-50%)';
  });
  startOverlay();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function(){ vh = window.innerHeight; onScroll(); }, { passive: true });
  update();

})();
